export const clientPackageProfileModel = (profile: IClientPackageProfile): IClientPackageProfileModel => ({
	clientId: profile.client_id,
	uuid: profile.uuid,
	firstName: profile.first_name,
	lastName: profile.last_name,
	street: profile.street,
	postcode: profile.postcode,
	city: profile.city,
	gender: profile.gender,
	birthDate: profile.birth_date ? new Date(profile.birth_date) : null,
	dietExpectation: profile.diet_expectation,
	lifestyle: profile.lifestyle,
	weight: profile.weight,
	weightGoal: profile.weight_goal,
	height: profile.height,
	onboardingCompleted: profile.onboarding_completed,
	canReceiveInvitations: profile.can_receive_invitations,
	isInfluencer: profile.is_influencer,
	isEmployee: profile.is_employee,
})

export const clientPackageAddressModel = (address: IClientPackageAddress): IClientPackageAddressModel => ({
	id: address.id,
	uuid: address.uuid,
	isAssigned: address.is_assigned,
	buildingType: address.building_type,
	city: address.city,
	district: address.district,
	postcode: address.postcode,
	street: address.street,
	name: address.name,
	buildingNumber: address.building_number,
	apartmentNumber: address.apartment_number,
	staircase: address.staircase,
	floor: address.floor,
	entryCode: address.entry_code,
	deliveryFrom: address.delivery_from,
	deliveryUntil: address.delivery_until,
	deliveryPlace: address.delivery_place,
	deliveryPhoneNumber: address.delivery_phone_number,
	isAlternativeDeliveryPhoneNumber: address.is_alternative_delivery_phone_number,
	courierInstructions: address.courier_instructions,
	customName: address.custom_name,
	lastUsedDate: address.last_used_date ? new Date(address.last_used_date) : null,
	createdAt: new Date(address.created_at),
	updatedAt: new Date(address.updated_at),
})

export const clientPackageClientModel = (client: IClientPackageClient): IClientPackageClientModel => ({
	id: client.id,
	uuid: client.uuid,
	email: client.email,
	phoneNumber: client.phone_number,
	emailVerifiedAt: client.email_verified_at ? new Date(client.email_verified_at) : null,
	emailVerificationToken: client.email_verification_token,
	passwordResetToken: client.password_reset_token,
	temporaryEmail: client.temporary_email,
	preferredLanguage: client.preferred_language,
	emailChangeVerificationTokenExpiresAt: client.email_change_verification_token_expires_at
		? new Date(client.email_change_verification_token_expires_at)
		: null,
	isSocial: client.is_social,
	emailChange: client.email_change,
})

export const clientPackageDietModel = (diet: IClientPackageDiet): IClientPackageDietModel => ({
	id: diet.id,
	dietType: diet.diet_type,
	dietID: diet.diet_id,
	friendlyID: diet.friendly_id,
	uuid: diet.uuid,
	kcal: diet.kcal,
	status: diet.status,
	createdAt: new Date(diet.created_at),
	dietNickname: diet.diet_nickname,
	currentConfigDiet: diet.current_config_diet,
	clientProfile: clientPackageProfileModel(diet.client_profile),
	client: clientPackageClientModel(diet.client),
})

export const clientDietDayModel = (clientDietDay: IClientDietDay): IClientDietDayModel => ({
	id: clientDietDay.id,
	uuid: clientDietDay.uuid,
	date: new Date(clientDietDay.date),
	allMealsSelected: clientDietDay.all_meals_selected,
	status: clientDietDay.status,
	cartDietDayID: clientDietDay.cart_diet_day_id,
	addressID: clientDietDay.address_id,
	kcal: clientDietDay.kcal,
	dietID: clientDietDay.diet_id,
	dietLabel: clientDietDay.diet_label,
	dietType: clientDietDay.diet_type,
	paidPrice: clientDietDay.paid_price,
	paidCorePrice: clientDietDay.paid_core_price,
	paidDeliveryPrice: clientDietDay.paid_delivery_price,
	clientMealSlotsCount: clientDietDay.client_meal_slots_count,
	clientDiet: clientPackageDietModel(clientDietDay.client_diet),
	address: clientPackageAddressModel(clientDietDay.address),
})

export const clientPackageModel = (clientPackage: IClientPackage): IClientPackageModel => ({
	id: clientPackage.id,
	boxPackagingItemsCount: clientPackage.box_packaging_items_count,
	boxType: clientPackage.box_type,
	totalValue: clientPackage.total_value,
	totalWeight: clientPackage.total_weight,
	visualisationUrl: clientPackage.visualisation_url,
	inside: clientPackage.inside,
	status: clientPackage.status,
	statusShort: clientPackage.status_short,
	identifier: clientPackage.identifier,
	packageGuid: clientPackage.package_guid,
	regionIdentifier: clientPackage.region_identifier,
	regionForwarder: clientPackage.region_forwarder,
	regionBranch: clientPackage.region_branch,
	clientDietDay: clientDietDayModel(clientPackage.client_diet_day),
})

export const clientPackagesModel = (packages: IClientPackage[]): IClientPackageModel[] =>
	packages.map(clientPackageModel)
